import Dexie from "dexie";

const db = new Dexie('whatyouwish');

db.version(1).stores({
    auctionData: 'id,lotName,cost',
    wheelData: 'id,lotName,cost'
})

db.version(2).stores({
    auctionData: 'id,lotName,cost',
    wheelData: 'id,lotName,cost',
    wheelAppearance: 'id'
})

db.version(3).stores({
    auctionData: 'id,lotName,cost',
    wheelData: 'id,lotName,cost',
    wheelAppearance: 'id',
    wheelAppearanceThemes: 'id,name,updatedAt'
})

db.version(4).stores({
    auctionData: 'id,lotName,cost',
    wheelData: 'id,lotName,cost',
    wheelAppearance: 'id,themeId,updatedAt',
    wheelAppearanceThemes: 'id,name,type,updatedAt'
})

export const dbAdapter = {
    async saveAuctionData(data, store) {
        await db[store].put(data);
    },
    async saveAuctionDataBulk(data, store) {
        await db[store].bulkPut(data);
    },
    async resetAuctionDataCost(store) {
        await db[store].toCollection().modify(lot => lot.cost = 1);
    },
    async loadAuctionData(store) {
        return await db[store].toCollection()
            .reverse()
            .sortBy('cost');
    },
    async removeAuctionData(data, store) {
        await db[store].delete(data.id);
    },
    async searchAuctionData(term, store) {
        return await db[store].where('lotName')
            .startsWithIgnoreCase(term)
            .reverse()
            .sortBy('cost');
    },
    async clearAuctionData(store) {
        db[store].clear();
    },
    async loadWheelAppearance() {
        return await db.wheelAppearance.get('current');
    },
    async saveWheelAppearance(value) {
        await db.wheelAppearance.put({ id: 'current', value });
    },
    async clearWheelAppearance() {
        await db.wheelAppearance.delete('current');
    },
    async loadWheelAppearanceDraft() {
        return await db.wheelAppearance.get('draft');
    },
    async saveWheelAppearanceDraft(themeId, value) {
        await db.wheelAppearance.put({
            id: 'draft',
            themeId,
            value,
            updatedAt: Date.now(),
        });
    },
    async clearWheelAppearanceDraft() {
        await db.wheelAppearance.delete('draft');
    },
    async loadWheelAppearanceThemes() {
        return await db.wheelAppearanceThemes
            .orderBy('updatedAt')
            .reverse()
            .toArray();
    },
    async saveWheelAppearanceTheme(theme) {
        await db.wheelAppearanceThemes.put(theme);
    },
    async removeWheelAppearanceTheme(themeId) {
        await db.wheelAppearanceThemes.delete(themeId);
    },
    async migrateWheelAppearanceThemes({ themeId, fallbackWheel }) {
        return await db.transaction('rw', db.wheelAppearance, db.wheelAppearanceThemes, async () => {
            const savedThemes = await db.wheelAppearanceThemes.toArray();
            const themes = savedThemes.map((theme) => {
                if (theme.type === 'custom' && theme.appearance && theme.wheel) {
                    return theme;
                }

                const updatedAt = theme.updatedAt || Date.now();
                return {
                    id: theme.id,
                    name: theme.name || 'Custom theme',
                    type: 'custom',
                    wheel: theme.wheel || fallbackWheel,
                    appearance: theme.appearance || theme.value,
                    createdAt: theme.createdAt || updatedAt,
                    updatedAt,
                };
            });

            if (themes.some((theme, index) => theme !== savedThemes[index])) {
                await db.wheelAppearanceThemes.bulkPut(themes);
            }

            let draft = await db.wheelAppearance.get('draft');
            const legacyAppearance = await db.wheelAppearance.get('current');
            if (!draft && legacyAppearance?.value) {
                draft = {
                    id: 'draft',
                    themeId,
                    value: legacyAppearance.value,
                    updatedAt: Date.now(),
                };
                await db.wheelAppearance.put(draft);
                await db.wheelAppearance.delete('current');
            }

            return { themes, draft };
        });
    }
}
